// extracted by mini-css-extract-plugin
module.exports = {"invalid":"Input_invalid__1XscM"};